import * as hexCSS from './hex.scss';

const hex = __NATIVE__ ? hexCSS : hexCSS.default;
const hexKeys = Object.keys(hex).filter(key => typeof hex[key] === 'string');

function parseColorNames() {
  return hexKeys.reduce((obj, name) => {
    const key = name.replace(/-/g, '_');
    obj[key.toUpperCase()] = name;
    return obj;
  }, {});
}

export default parseColorNames();
